export var removeTipAndEntitlementsOptions = {
  "tip": 0,
  "promo": 1,
  "giftCard": 2
};